import React, { useState } from 'react'
import { MenuItem, Menu, Tooltip, Button, IconButton, Divider, Typography } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTableStore } from 'state/TableStore';
import EditIcon from '@mui/icons-material/Edit';
import { useUserStore } from 'state';
import dayjs from 'dayjs';

export const Actions: React.FC<any> = ({ row, pageName, isCurrentRowClicked, rowClickHandler, tableName }) => {
    const userConfig = useUserStore(state => state.userConfig)
    const config = useUserStore(state => state.config)
    const { usersPermissions } = userConfig;
    const { maxExtensions, hardLimit, setExpireOnResponse } = config.transactionViewing

    const [anchorEl, setAnchorEl] = useState(null);
    const openActions = Boolean(anchorEl);

    const currentRow = useTableStore((state) => state.currentRow)
    const setCurrentRow = useTableStore((state) => state.setCurrentRow)
    const actionsConfig = useTableStore(state => state.actionsConfig)

    const popoverId = openActions ? 'actions-popover' : undefined;

    const handleOpenActions = (e: any, key: string) => {
        e.stopPropagation()
        setCurrentRow(key)
        setAnchorEl(e.currentTarget);
    }

    const handleClose = (e: any) => {
        e.stopPropagation()
        setAnchorEl(null);
    };

    console.log({ pageName, actionsConfig, rowKeyOrId: row.key, rowId: row.id, row })
    return (
        <>
            {
                pageName === 'user-management'
                    ? currentRow === row.key &&
                    <Button size='small' sx={{ width: `67px`, height: `30px` }} onClick={(e) => rowClickHandler(e, row)} data-testid="edit-button">
                        <EditIcon sx={{ mr: '0.5rem', width: `18px`, height: `18px` }} />
                        <Typography variant="button" sx={{ fontSize: `14px` }}>
                            Edit
                        </Typography>
                    </Button>
                    : (row.key ? row.key : row.id) && <Tooltip title="Open Actions">
                        <IconButton key={row.key}
                            sx={{ marginLeft: "", height: "20px", width: "20px" }}
                            data-testid="open-actions-icon-button"
                            onClick={(e: any) => {
                                e.stopPropagation();
                                handleOpenActions(e, row.key)
                            }
                            } aria-label='Open actions'>
                            <MoreVertIcon />
                        </IconButton>
                    </Tooltip>
            }
            {
                row.key === currentRow && (
                    <Menu
                        onClose={(e) => handleClose(e)}
                        slotProps={{ paper: { sx: { width: (pageName === 'transaction-summary' || pageName === 'applicant-details') ? '220px' : '270px', backgroundColor: "background.default", border: "none", display: 'flex', flexDirection: "column" } } }}
                        id={popoverId}
                        open={openActions}
                        data-testid="actions-menu"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        anchorEl={anchorEl}
                        MenuListProps={{ 'aria-label': 'Menu list' }}>
                        {

                            (pageName === 'transaction-summary' || pageName === 'applicant-details' || pageName === 'rapback-summary') && (
                                actionsConfig.map((action) => {
                                    console.log('debug actions actionsCofnig: ', actionsConfig, row)
                                    console.log('row key, action label: ', row.key + action.actionLabel)
                                    let hardLimitReached: boolean;

                                    if (setExpireOnResponse && row?.responseDate === null) {
                                        hardLimitReached = false;
                                    } else {
                                        hardLimitReached = dayjs((setExpireOnResponse) ? row?.responseDate : row?.transactionDate).add(hardLimit, 'days').isBefore(dayjs());
                                    }

                                    const disableExtend = row.extendCount >= maxExtensions || hardLimitReached || row.expireDate === null;
                                    return (action.actionLabel === "Extend"
                                        ? usersPermissions?.extendTransactionRecord &&
                                        <MenuItem disabled={disableExtend} key={row.key + action.actionLabel}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            data-testid="actions-menu-item"
                                            aria-label={action.actionLabel}
                                            sx={{ width: "270px", height: "36px", pointerEvents: disableExtend ? "none" : "" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                        : action.actionLabel === "_divider" ? <Divider aria-hidden role="separator" /> : <MenuItem key={action.actionLabel}
                                            disabled={action.actionLabel === "No PDF available" ? true : false}
                                            data-testid="actions-menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: '270px', height: "36px", }}
                                            aria-label={action.actionLabel}
                                        >
                                            {action.actionIcon ? action.actionIcon : <></>}
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }

                        {
                            pageName === 'rapback-maintenance' && (
                                actionsConfig.map((action) => {
                                    return (
                                        action.actionLabel === "_divider"
                                            ? <Divider aria-hidden role="separator" />
                                            : <MenuItem key={row.key + action.actionLabel}
                                                disabled={(action.actionLabel === "Edit Subscription" || action.actionLabel === "Unsubscribe") && (row.status?.toLowerCase() === "unsubscribed" || row.status?.toLowerCase().includes("pending"))}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleClose(e)
                                                    action.actionHandler(e, row)
                                                }}
                                                data-testid="actions-menu-item"
                                                sx={{ width: "270px", height: "36px" }}>
                                                {action.actionLabel}
                                            </MenuItem>
                                    )
                                })

                            )
                        }
                        {
                            pageName === 'rapback-prenotifications' && (
                                actionsConfig.map((action) => {
                                    return (
                                        <MenuItem
                                            key={row.key + action.actionLabel}
                                            data-testid="actions-menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: "270px", height: "36px" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }
                        {
                            pageName === 'rapback-validations' && (
                                actionsConfig.map((action) => {
                                    return (
                                        <MenuItem
                                            disabled={Math.sign(row.timeRemaining) < 1 ? true : false}
                                            data-testid="actions-menu-item"
                                            key={row.key + action.actionLabel}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: "270px", height: "36px" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }
                    </Menu>
                )
            }
        </>
    )

}
